import ShoppingCart from './views/ShoppingCart/ShoppingCart';
import TicketList from './views/Orders/Ticket';
import InvoiceList from './views/Orders/Invoice';
import ProductList from './views/Products/List';
import ClientList from './views/Clients/List';
import AccountBook from './views/Orders/AccountBook';
import UserProfile from  './views/Users/Profile';
import AdminSettings from './views/Admin/Settings';

const routes = [
 { path: '/cart', exact: true, name: 'Punto de venta / compra', component: ShoppingCart },
 { path: '/tickets', exact: true, name: 'Tickets', component: TicketList },
 { path: '/invoices', exact: true, name: 'Facturas', component: InvoiceList },
 { path: '/products', exact: true, name: 'Productos', component: ProductList },
 { path: '/clients', exact: true, name: 'Clientes', component: ClientList },
 { path: '/account', exact: true, name: 'Libro de cuentas', component: AccountBook },
 { path: '/profile', exact: true, name: 'Perfil de usuario', component: UserProfile },
 { path: '/settings', exact: true, name: 'Configuración', component: AdminSettings }
]

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js